module.exports = __webpack_public_path__ + "static/media/b9.af325ab4.png";